export default __webpack_public_path__ + "static/media/faqimage5.70d769a6.jpg";